import { parseResponse } from "../../utils/common_lib";
import { baseApi } from "../baseApi";
export const demographicsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDemographics: builder.query({
      query: (params) => {
        return {
          url: `/demographics/get_demographics.json`,
          method: "GET",
          params: params,
        };
      },
      providesTags:["Demographics"],
      transformResponse: (response, meta, arg) => {
        return parseResponse(response);
      },
    }),
    getContacts: builder.query({
      query: (params) => {
        return {
          url: `/demographics/get_contacts.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => {
        return parseResponse(response);
      },
    }),
    getConsents: builder.query({
      query: (params) => {
        return {
          url: `/patients/get_consents.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => {
        return parseResponse(response);
      },
    }),
    getInsurances: builder.query({
      query: (params) => {
        return {
          url: `/demographics/patient_insurances.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => {
        return parseResponse(response);
      },
    }),
    getDemographicListing: builder.query({
      query: (params) => {
        return {
          url: `/demographics/listing.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => {
        return parseResponse(response);
      },
    }),
    getHistory: builder.query({
      query: (params) => {
        return {
          url: `/amendments/list_requests.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => {
        return parseResponse(response);
      },
    }),
    getLanguage: builder.query({
      query: (data) => {
        return {
          url: `/utilities/listing/language.json`,
          method: "GET",
          params: data,
        };
      },
    }),
    amendmentRequest: builder.mutation({
      query: (data) => {
        return {
          url: `/amendments/request.json`,
          method: "POST",
          body: data,
        };
      },
      invalidatesTags:["Demographics"],
      transformResponse: (response, meta, arg) => {
        return parseResponse(response);
      },
    }),
    cancelAmendment: builder.query({
      query: (params) => {
        return {
          url: `/amendments/cancel_request.json`,
          method: "GET",
          params: params,
        };
      },
      invalidatesTags:["Demographics"],
      transformResponse: (response, meta, arg) => {
        return parseResponse(response);
      },
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetDemographicsQuery,
  useGetContactsQuery,
  useGetConsentsQuery,
  useGetInsurancesQuery,
  useGetDemographicListingQuery,
  useGetHistoryQuery,
  useGetLanguageQuery,
  useAmendmentRequestMutation,
} = demographicsApi;
